import { useEffect, useState } from 'react';
import { Session } from '@supabase/supabase-js';
import supabase from '../supabase';
import { LoadingSpinner } from '../components/ui/loading-spinner';
import { SessionContext } from './session-context';

type Props = { children: React.ReactNode };

export const SessionProvider = ({ children }: Props) => {
  const [session, setSession] = useState<Session | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const authStateListener = supabase.auth.onAuthStateChange(
      async (_, session) => {
        setSession(session);
        setIsLoading(false);
      },
    );

    return () => {
      authStateListener.data.subscription.unsubscribe();
    };
  }, []);

  return (
    <SessionContext.Provider value={{ session }}>
      {isLoading ? <LoadingSpinner /> : children}
    </SessionContext.Provider>
  );
};
